module.exports = __webpack_public_path__ + "static/media/stenny.78e4379a.png";